import { Music, Mic, Heart } from "lucide-react";
import { to12Hour } from "../lib/time";
import { T } from "../lib/i18n";

const KIND_LABEL = {
  ceremony: "Ceremony",
  speech: "Speech",
  dance: "Dance",
  toast: "Toast",
};

export default function SpeechCard({ item, large = false }) {
  if (!item.profile_attached) return null;
  return (
    <div className={`card-elev fadein ${large ? "p-8" : "p-5"}`} data-testid={`speech-card-${item.id}`}>
      <div className="flex items-baseline gap-3 mb-3">
        <div className={`font-display text-primary-motif ${large ? "text-5xl" : "text-2xl"}`}>{to12Hour(item.time)}</div>
        <div className="text-[10px] tracking-luxe text-motif-muted">{T(KIND_LABEL[item.kind] || item.kind)}</div>
      </div>
      <div className={`font-display text-motif leading-tight ${large ? "text-4xl" : "text-xl"}`}>{item.title}</div>
      {item.profile_name && (
        <div className={`text-motif-muted ${large ? "text-lg mt-2" : "text-sm mt-1"}`}>
          {item.profile_name} {item.relationship ? `· ${item.relationship}` : ""}
        </div>
      )}
      {item.song_title && (
        <div className={`flex items-center gap-2 ${large ? "text-xl mt-4" : "text-sm mt-3"} text-motif`}>
          <Music className={large ? "w-5 h-5" : "w-3.5 h-3.5"} strokeWidth={1.5} />
          <span className="font-display italic">"{item.song_title}"</span>
          {item.song_artist && <span className="text-motif-muted">— {item.song_artist}</span>}
        </div>
      )}
      {item.quote && (
        <blockquote className={`border-l-2 border-primary-motif pl-3 italic text-motif ${large ? "text-2xl mt-5 font-display" : "text-sm mt-3"}`}>
          {item.quote}
        </blockquote>
      )}
      {item.fun_fact && (
        <div className={`flex items-start gap-2 text-motif-muted ${large ? "text-base mt-4" : "text-xs mt-3"}`}>
          <Heart className={large ? "w-4 h-4 mt-1 flex-shrink-0" : "w-3 h-3 mt-0.5 flex-shrink-0"} strokeWidth={1.5} />
          <span>{item.fun_fact}</span>
        </div>
      )}
      {item.description && !item.fun_fact && (
        <div className={`text-motif-muted ${large ? "text-base mt-3" : "text-xs mt-2"}`}>{item.description}</div>
      )}
    </div>
  );
}
